import { Button, Modal} from "react-bootstrap";

export default function Notification({modalShow, setModalShow, message, spinner, closeButton}) {

    const handleClose = () => setModalShow(false);
    

    return (
      <>
        <Modal
            show={modalShow === true ? true : false}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered    
            animation={false}
            >
            
            <Modal.Body>
                <br/>
                <div className="m-auto text-center">{message}</div> <br/><br/>                
                {closeButton ?            
                <div className="m-auto text-center"><Button variant="secondary" onClick={handleClose}>
                Close
                </Button> </div>
            :
            spinner ?
                <div className="loader m-auto"></div>
                :""                
            }
            <br/>
            </Modal.Body>            
        </Modal>
      </>
    );
  }